<template>
  <a-modal v-model="visible" :title="$t('日志信息')" :width="1000" destroyOnClose>
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
    </div>
    <a-descriptions :column="3" bordered>
      <a-descriptions-item :label="$t('标题')">
        {{ log.title }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('业务类型')">
        {{ log.businessType }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('操作人')">
        {{ log.operatorName }}({{ log.operatorId }})
      </a-descriptions-item>
      <a-descriptions-item :label="$t('请求方法')">
        {{ log.requestMethod }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('链接地址')">
        {{ log.operatorUrl }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('请求IP')">
        {{ log.operatorIp }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('操作系统')">
        {{ log.operatorOs }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('浏览器')">
        {{ log.operatorBrowser }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('返回状态')">
        {{ log.resStatus }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('所属应用')">
        {{ log.appId }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('请求时间')">
        {{ log.operatorTime }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('响应时间')">
        {{ log.resTime }}
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>

export default {
  data() {
    return {
      visible: false,
      log: {},
      loading: false,
    }
  },
  methods: {
    show(data) {
      this.log = { ...data }
      this.visible = true
    },
  }
}
</script>